import { Modal } from "antd";
import "./CreateFolderModal.scss";
import { MenuFolderDto } from "../../generated/dashboard-client";
import { CreateFolderContent } from "./CreateFolderContent";

export interface CreateFolderModalProps {
  ids: string[];
  isVisible: boolean;
  onClose: (ids: string[], folderToMove?: MenuFolderDto | null, folder?: MenuFolderDto) => void;
  folderToMove: MenuFolderDto | null,
  folderNameExists: (folder: MenuFolderDto | null, name: string) => boolean | undefined;
  activeFolder: MenuFolderDto | null
}

export function CreateFolderModal({
  ids,
  isVisible,
  onClose,
  folderToMove,
  folderNameExists,
  activeFolder
}: CreateFolderModalProps) {
  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose([])}
    >
      <CreateFolderContent
        ids={ids}
        onClose={onClose}
        folderToMove={folderToMove}
        parentFolder={activeFolder}
        folderNameExists={folderNameExists}
      />
    </Modal>
  );
}
